var map = {
	"./aiSecurity/cn.json": [
		4244,
		64
	],
	"./dataLeakage/cn.json": [
		4245,
		67
	],
	"./ppd/cn.json": [
		4246,
		70
	],
	"./ransomware/cn.json": [
		4247,
		73
	],
	"./socialMedia/cn.json": [
		4248,
		76
	],
	"./whatsApp/cn.json": [
		4249,
		79
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 858;
module.exports = webpackAsyncContext;